/* eslint-disable react/prop-types */
import React from 'react';
import { ZCDTooltip, ZCDIcon, ZCDIconColor, ZCDFlex } from '@zencity/common-ui';
// import { formatDate } from '../../../../../i18n/date';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { datasetColors, TopicAnalysisStatus } from '../../../enum';
import TopicAnalysisCard from './TopicAnalysisCard';
import TopicAnalysisErrorStates from './TopicAnalysisErrorStates';

/**
 * Topic Anaysis:
 * Ported from civilspace-client-instances-management
 */

function TopicAnalysis({ topicState, dispatchTopicAnalysis, isReportBuilder }) {
  const { t } = useTranslation();
  const topicSummaryData = topicState.topicSummary;
  const onExpandAll = () => {
    if (dispatchTopicAnalysis) {
      dispatchTopicAnalysis({ type: 'expandAll' });
    }
  };
  const onCollapseAll = () => {
    if (dispatchTopicAnalysis) {
      dispatchTopicAnalysis({ type: 'collapseAll' });
    }
  };
  const canShowTopicAnalysis =
    topicSummaryData.status === TopicAnalysisStatus.SUCCESS &&
    topicSummaryData.topics &&
    topicSummaryData.topics.length > 0;
  return (
    <>
      <ZCDFlex justifyContent="space-between" className={'engage-topic-results-header'}>
        <ZCDFlex className={'engage-topic-results-header-left'}>
          <strong>{t(`topicAnalysis.topicAnalysisTitle`)}</strong>{' '}
          {topicSummaryData.runOn && (
            <span className={'engage-topic-runon'}>
              {t(`topicAnalysis.runOn`)}
              {format(new Date(topicSummaryData.runOn), 'MMMM d, yyyy')}
            </span>
          )}{' '}
          {!isReportBuilder && (
            <ZCDTooltip text={t('topicAnalysis.explainTopicAnalysis')}>
              <ZCDIcon name="info" color={ZCDIconColor.BLUE} />
            </ZCDTooltip>
          )}
        </ZCDFlex>
        {canShowTopicAnalysis && !isReportBuilder && (
          <ZCDFlex className={'engage-topic-results-header-left'}>
            <span
              className={'engage-topic-expand-collapse-toggle'}
              onClick={onExpandAll}
              data-testid="topics-expandall"
            >
              {t(`topicAnalysis.expandAll`)}
            </span>
            <span
              className={'engage-topic-expand-collapse-toggle'}
              onClick={onCollapseAll}
              data-testid="topics-collapseall"
            >
              {t(`topicAnalysis.collapseAll`)}
            </span>
          </ZCDFlex>
        )}
      </ZCDFlex>

      {!canShowTopicAnalysis && (
        <TopicAnalysisErrorStates status={topicSummaryData.status} tags={topicSummaryData.tags} />
      )}

      {canShowTopicAnalysis &&
        topicSummaryData.topics &&
        topicSummaryData.topics.map((topic, topicIndex) => {
          return (
            <TopicAnalysisCard
              key={topic.name}
              topic={topic}
              color={datasetColors[topicIndex % datasetColors.length]}
              colorIndex={topicIndex % datasetColors.length}
              filters={topicState?.filters || []}
              expanded={topicState?.expanded || []}
              isReportBuilder={isReportBuilder}
              dispatchTopicAnalysis={dispatchTopicAnalysis}
            />
          );
        })}
    </>
  );
}

export default TopicAnalysis;
